import { useDynamicFormFieldById } from 'components/DynamicForm/state';
import { get, isEqual } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';

const UNDEFINED_VALUE_SHOW_ON = 'UNDEFINED_VALUE_SHOW_ON';

const ShowOnFieldWrapper = ({ name, id, showOnConfig, children }) => {
  const [showField, setShowField] = useState(false);
  const { field } = useDynamicFormFieldById({ fieldId: id });
  const listenedFields = useWatch({
    name: showOnConfig.fields,
    defaultValue: UNDEFINED_VALUE_SHOW_ON,
  });

  const determinateShow = useCallback(async () => {
    if (listenedFields !== UNDEFINED_VALUE_SHOW_ON && field?.id) {
      try {
        if (typeof showOnConfig?.custom === 'function') {
          const canShow = await showOnConfig.custom({ listenedFields, fieldState: field });
          setShowField(canShow);
        } else {
          const values = showOnConfig?.fields?.map((fieldItem) =>
            get(listenedFields, fieldItem, UNDEFINED_VALUE_SHOW_ON)
          );
          setShowField(isEqual(values, showOnConfig?.values || null));
        }
      } catch (error) {
        console.error('Error in determinateShow:', error);
      }
    }
  }, [listenedFields, showOnConfig, field]);

  useEffect(() => {
    determinateShow();
  }, [determinateShow]);

  return children({ showField });
};

export default ShowOnFieldWrapper;
